const clientPaths = require('./client-path.js')

// 注意事项：包名修改 src\config\secret-key.js里的包名也要修改
const apps = {
  default: {
    schema: 'imee://',
    clientPath: clientPaths.default,
  },
  echo: {
    schema: 'echo://',
    // 正式 测试 测试
    hosts: ['www.echoapp.chat', 'dewidfp7zx5np.cloudfront.net', 'd1ttx9a5vofxx7.cloudfront.net'],
    // 测试 安卓 苹果
    packages: ['com.example.echo', 'com.chat.whisper', 'com.fh.whisper.chat'],
    // ios测试 苹果正式
    iosPackages: [],
    // 测试 安卓
    androidPackages: ['com.example.echo', 'com.chat.whisper'],
    // 客户端路径
    clientPath: clientPaths.echo,
    // 接口调用地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'dewidfp7zx5np.cloudfront.net' : 'd1ttx9a5vofxx7.cloudfront.net',
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.echoapp.chat' : 'd1ttx9a5vofxx7.cloudfront.net',
  },
  joychat: {
    schema: 'joychat://',
    // 正式 正式 测试
    hosts: ['www.joyme.chat', 'app.joyme.chat', 'dr9gc3kyysxu5.cloudfront.net'],
    // all
    packages: ['com.owner.chat', 'com.chat.joychat'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.owner.chat', 'com.chat.joychat'],
    // 客户端路径
    clientPath: clientPaths.joychat,
    // 接口调用地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.joyme.chat' : 'app.test.camfan.chat',
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'app.joyme.chat' : 'dr9gc3kyysxu5.cloudfront.net',
  },
  joyu: {
    schema: 'joyu://',
    // 正式 测试
    hosts: ['www.mind-link.chat', 'd30296ri52vin5.cloudfront.net'],
    // all
    packages: ['com.example.joyu', 'com.mind.joyu'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.joyu', 'com.mind.joyu'],
    // 客户端路径
    clientPath: clientPaths.joyu,
    // 接口调用地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'sev.mind-link.chat' : 'd30296ri52vin5.cloudfront.net',
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.mind-link.chat' : 'd30296ri52vin5.cloudfront.net',
  },
  kiko: {
    schema: 'kiko://',
    // 正式 正式 正式 测试
    hosts: ['www.kikoapp.chat', 'www.inpulse.fun', 'app.inpulse.fun', 'app.test.inpulse.fun'],
    // all
    packages: ['com.example.kiko', 'com.live.kiko', 'com.test.moodlink', 'com.date.moodlink'],
    // 测试 正式
    iosPackages: ['com.test.moodlink', 'com.date.moodlink'],
    // 测试 正式
    androidPackages: ['com.example.kiko', 'com.live.kiko'],
    // 客户端路径
    clientPath: clientPaths.kiko,
    // 接口调用地址
    apiBaseURL: {
      android: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.inpulse.fun' : 'app.test.inpulse.fun',
      ios: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.inpulse.cc' : 'inpulse.test.inpulse.cc',
    },
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.kikoapp.chat' : 'app.test.inpulse.fun',
  },
  vava: {
    schema: 'imee://',
    // 正式 正式 正式 测试
    hosts: ['www.vava.chat', 'www.camfan.chat', 'app.camfan.chat', 'app.test.camfan.chat'],
    // all
    packages: ['com.example.gcc', 'com.client.goparty', 'com.test.coach', 'com.tools.coach'],
    // 测试 正式
    iosPackages: ['com.test.coach', 'com.tools.coach'],
    // 测试 正式
    androidPackages: ['com.example.gcc', 'com.client.goparty'],
    // 客户端路径
    clientPath: clientPaths.vava,
    // 接口调用地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.camfan.chat' : 'app.test.camfan.chat',
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'app.camfan.chat' : 'app.test.camfan.chat',
  },
  vibeo: {
    schema: 'vibeo://',
    // 正式 测试
    hosts: ['web.vervachat.com', 'vibeo.test.vervachat.com'],
    // all
    packages: ['com.example.vibeo', 'com.live.vibeo'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.vibeo', 'com.live.vibeo'],
    // 客户端路径
    clientPath: clientPaths.vibeo,
    // 接口调用地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'vbi.vervachat.com' : 'vibeo.test.vervachat.com',
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'web.vervachat.com' : 'vibeo.test.vervachat.com',
  },
  whonow: {
    schema: 'whonow://',
    // 正式 测试
    hosts: ['www.linkup.chat', 'd31j2n3w70svmb.cloudfront.net'],
    // all
    packages: ['com.example.whonow', 'com.linkup.chat.whonow'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.whonow', 'com.linkup.chat.whonow'],
    // 客户端路径
    clientPath: clientPaths.whonow,
    // 接口调用地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'dwogpybf1cxs0.cloudfront.net' : 'd31j2n3w70svmb.cloudfront.net',
    // 分享页域名
    shareAddress: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.linkup.chat' : 'd31j2n3w70svmb.cloudfront.net',
  },
  vavaWeb: {
    // h5
    packages: ['com.vava.chat.web'],
    iosPackages: [],
    androidPackages: ['com.vava.chat.web'],
  },
}

const baseConfig = {
  apps,
  // app包名 [测试 安卓 苹果] 简写，由 apps.packages 自动生成
  packageNameMap: Object.entries(apps).reduce((map, [shortName, app]) => {
    ;(app.packages || []).forEach((pkg) => {
      map[pkg] = shortName
    })
    return map
  }, {}),
  // 环境类型
  isRelease: process.env.VUE_APP_IS_RELEASE == 1,
  // 图片地址
  imgHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'https://source.camfan.chat/' : 'https://source.camfan.chat/',
  // 右向左语言列表
  rtlLangs: ['ar', 'fa', 'he'],
  // 现有web包
  validWebPackage: ['vavaWeb'],
  // 现有app包
  validAppPackage: ['echo', 'joychat', 'joyu', 'kiko', 'vava', 'vibeo', 'whonow'],
  /**
   * postcss-pxtorem.rootValue 与 src/assets/style/variable.js 中 px→rem 共用基准。
   * 约定：375 设计稿宽度下配合 flexible，`html` 字号为视口宽 / 10，此时 1rem ≈ 37.5px。
   */
  remRootValue: 37.5,
  // 各包应用商店下载链接
  downloadLinks: {
    echo: {
      android: 'https://play.google.com/store/apps/details?id=com.chat.whisper',
      ios: 'https://apps.apple.com/us/app/echo-secret-share-virtual-link/id6479391629',
    },
    beautycircle: { android: '', ios: 'https://itunes.apple.com/app/id6771731152' },
    joychat: { android: 'https://play.google.com/store/apps/details?id=com.chat.joychat', ios: '' },
    joyu: { android: 'https://play.google.com/store/apps/details?id=com.mind.joyu', ios: '' },
    kiko: { android: 'https://play.google.com/store/apps/details?id=com.live.kiko', ios: '' },
    vava: { android: 'https://play.google.com/store/apps/details?id=com.client.goparty', ios: '' },
    vibeo: { android: 'https://play.google.com/store/apps/details?id=com.live.vibeo', ios: '' },
    whonow: { android: 'https://play.google.com/store/apps/details?id=com.live.whonow', ios: '' },
  },
}

module.exports = baseConfig
